import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
// import { bootstrap } from '@angular/platform-browser-dynamic';
import { RouterModule } from '@angular/router';
// import { UniversalModule } from 'angular2-universal';
import { Http, RequestOptions, HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgZorroAntdModule, NZ_I18N, en_US, ja_JP } from 'ng-zorro-antd';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AUTH_PROVIDERS, AuthHttp, provideAuth, AuthConfig } from 'angular2-jwt';
import { Fmt } from './fmt.service';

// app components
import { AppComponent } from './app/app/app.component'
import { NavMenuComponent } from './app/navmenu/navmenu.component';
import { HomeComponent } from './app/home/home.component';
import { WsUsageComponent } from './app/wsusage/wsusage.component';
import { WsSettingDialogComponent } from './app/wssettingDialog/wssettingDialog.component';
import { WhitelistComponent } from './app/whitelist/whitelist.component';
import { LoginComponent } from './app/auth/login.component';
import { ProjectTemplateComponent } from './app/projectTemplates/projectTemplates.component';

import { WsUsageFIlter } from './app/wsusage/wsusage.filter';
import { Auth } from './auth.service';
import { AuthGuard } from './authguard.service';
import { BrowserModule } from '@angular/platform-browser';

// import 'bootstrap/dist/bootstrap.css'

@NgModule({
    bootstrap: [
        AppComponent,
    ],
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        WsUsageComponent,
        WsSettingDialogComponent,
        WhitelistComponent,
        LoginComponent,
        WsUsageFIlter,
        ProjectTemplateComponent
    ],
    providers: [
        AUTH_PROVIDERS,
        Fmt,
        // provideAuth({
        //     noJwtError: true
        // }),
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        },
        AuthGuard,
        Auth,
        { provide: NZ_I18N, useValue: ja_JP }
    ],
    imports: [
        FormsModule,
        BrowserModule,
        HttpClientModule,
        HttpModule,
        BrowserAnimationsModule,
        NgZorroAntdModule,
        FormsModule,
        ReactiveFormsModule,
        // UniversalModule, // Must be first import. This automatically imports BrowserModule, HttpModule, and JsonpModule too.
        RouterModule.forRoot([
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
            { path: 'wsusage', component: WsUsageComponent, canActivate: [AuthGuard] },
            { path: 'wssetting_dialog', component: WsSettingDialogComponent, canActivate: [AuthGuard] },
            { path: 'whitelist', component: WhitelistComponent, canActivate: [AuthGuard] },
            { path: 'project_template', component: ProjectTemplateComponent, canActivate: [AuthGuard] },
            { path: 'login', component: LoginComponent },
            { path: 'unauthorized', component: LoginComponent },
            { path: '**', redirectTo: 'home', canActivate: [AuthGuard] }
        ])
    ],
    schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
    tokenName: 'token',
		tokenGetter: (() => localStorage.getItem('token')),
		globalHeaders: [{'Content-Type':'application/json'}],
	}), http, options);
}
